module.exports = __webpack_public_path__ + "img/jr3.010d85a3.png";